module.exports = __webpack_public_path__ + "static/media/nie-czas-na-nude.fea03cce.jpg";